import React from 'react';

import Slider from 'react-slick';

const processes = [
  {
    index: 1,
    title: 'Discovery',
    shortened:
      'As a professional motion graphics explainer video company, first we dive deep into understanding your product, audience, and key message. Through briefs, your inputs, and our comprehensive research, we distill the essence of your narrative. This foundation ensures our explainer video aligns seamlessly with your vision.',
    text: 'As a professional motion graphics explainer video company, first we dive deep into understanding your product, audience, and key message. Through briefs, your inputs, and our comprehensive research, we distill the essence of your narrative. This foundation ensures our explainer video aligns seamlessly with your vision.',
  },
  {
    index: 2,
    title: 'Script',
    shortened:
      "We translate your message into a captivating script. Accompanied by a storyboard, you get a scene-by-scene preview resembling a comic, illustrating the video's progression and ensuring every detail resonates.",
    text: "We translate your message into a captivating script. Accompanied by a storyboard, you get a scene-by-scene preview resembling a comic, illustrating the video's progression and ensuring every detail resonates.",
  },
  {
    index: 3,
    title: 'Voiceover',
    shortened:
      "Adding a distinct personality to your video, we introduce audio layers. We present a curated list of professional voice artists, aligning with your preferences. You then select the voice that captures your video's essence perfectly.",
    text: "Adding a distinct personality to your video, we introduce audio layers. We present a curated list of professional voice artists, aligning with your preferences. You then select the voice that captures your video's essence perfectly.",
  },
  {
    index: 4,
    title: 'Illustration',
    shortened:
      "Post storyboard and script refinement, our team crafts custom graphic illustrations. Every design detail is honed to emphasize your brand's unique colors and attributes, ensuring a resonant visual narrative",
    text: "Post storyboard and script refinement, our team crafts custom graphic illustrations. Every design detail is honed to emphasize your brand's unique colors and attributes, ensuring a resonant visual narrative",
  },
  {
    index: 5,
    title: 'Animation',
    shortened:
      'With design confirmations in place, we animate your illustrations. This phase sees your vision come alive. Sound designers then integrate voiceovers, music, and effects, completing the visual storytelling.',
    text: 'With design confirmations in place, we animate your illustrations. This phase sees your vision come alive. Sound designers then integrate voiceovers, music, and effects, completing the visual storytelling.',
  },
  {
    index: 6,
    title: 'Final Delivery',
    shortened:
      'Concluding our process, we deliver your explainer video, optimized for your preferred platform—be it your website, social media, or beyond. You also receive all source materials, offering flexibility for any future modifications.',
    text: 'Concluding our process, we deliver your explainer video, optimized for your preferred platform—be it your website, social media, or beyond. You also receive all source materials, offering flexibility for any future modifications.',
  },
];

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-next"
      className="arrow-next cursor-pointer absolute"
      style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      id="arrow-prev"
      className="arrow-prev hidden cursor-pointer absolute -left-30"
      style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

export default function SimpleSlider() {
  var settings = {
    infinite: false,
    speed: 300,
    swipe: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
        },
      },
    ],
    afterChange: function (a, b) {
      if (a == 0) {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'none';
        }
      } else if (a == 3) {
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'none';
        }
      } else {
        if (document.getElementById('arrow-prev')) {
          document.getElementById('arrow-prev').style.display = 'block';
        }
        if (document.getElementById('arrow-next')) {
          document.getElementById('arrow-next').style.display = 'block';
        }
      }

      var el = document.getElementById('process-row');

      if (el) {
        el.style.width = `${Math.min((a + 1) * (100 / (window.innerWidth > 768 ? 4 : 6)), 100)}%`;
      }
    },
  };

  return (
    <div>
      <div className="relative mb-15">
        <div className="w-full h-2 bg-gray-slider"></div>
        <div
          id="process-row"
          className="absolute left-0 h-4 bg-purple rounded-5 transition-all transition-500"
          style={{ top: '-1px', width: `${100 / 5}%` }}
        ></div>
      </div>

      <Slider {...settings} className="process-slider relative z-10">
        {processes.map((process, index) => (
          <div key={index} className="md:max-w-none mr-15 md:mr-30">
            <div className="relative z-10 pr-15 md:pr-23 h-full md:select-text">
              <div className="relative  sm:bg-auto md:bg-auto py-23  md:p-0 h-full">
                <p className="relative right-0 top-0 text-48 font-black leading-none text-gray-transparent md:text-pink pr-5 md:pr-0">
                  0{process.index}
                </p>

                <p className="text-14 lg:text-16 font-bold md:font-black text-green normal-case md:uppercase mb-23 md:mb-0 max-w-50 md:max-w-none">
                  {process.title}
                </p>

                <p className="text-14 max-w-50 md:max-w-none">
                  <span>{process.text}</span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
